import { render, staticRenderFns } from "./SdLeadIdentityHistoryTimeline.vue?vue&type=template&id=5620a4ae&"
import script from "./SdLeadIdentityHistoryTimeline.vue?vue&type=script&lang=js&"
export * from "./SdLeadIdentityHistoryTimeline.vue?vue&type=script&lang=js&"
import style0 from "./SdLeadIdentityHistoryTimeline.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SdLeadIdentityHistoryTimeline.vue"
export default component.exports